import axios from 'axios';
import { PatientRx, PatientRxModel } from '../models/patient-rx';

export const getPatientRxes = async (): Promise<Undefinable<PatientRx[]>> => {
    const response = await axios.get(`/api/patient-rx`);
    return response.data;
};

export const getPatientRxesAsync = async (): Promise<PatientRxModel[]> => {
    const response = await axios.get('/api/patient-rx');
    return response.data;
};
